var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{attrs:{"options":_vm.city,"props":_vm.propAdd},on:{"active-item-change":_vm.handleChange},model:{value:(_vm.hospAddArr),callback:function ($$v) {_vm.hospAddArr=$$v},expression:"hospAddArr"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f6e2ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/city.vue
// module id = null
// module chunks = 